import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { useLanguage } from '../../contexts/LanguageContext';

interface BlogPreviewProps {
  title: string;
  date: string;
  to: string;
}

const BlogPreview: React.FC<BlogPreviewProps> = ({ title, date, to }) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <Link 
      to={`/${language}${to}`} 
      className="block p-6 rounded-lg border border-[var(--brand-primary)]/20 bg-[var(--brand-primary)]/20 hover:border-[var(--brand-primary)]/40 transition-all duration-300"
    >
      <h3 className="text-xl font-bold text-[var(--text-primary)] mb-2 hover:text-[var(--brand-primary)] transition-colors">
        {title}
      </h3>
      <div className="flex items-center text-[var(--text-tertiary)] text-sm">
        <time dateTime={date}>
          {new Date(date).toLocaleDateString(t('blog.locale') || 'en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
        </time>
      </div>
      <span className="text-[var(--brand-primary)] hover:text-[var(--brand-hover)] font-medium mt-4 inline-block transition-colors">
        {t('blog.readMore')}
      </span>
    </Link>
  );
};

export default BlogPreview;